import React, { useEffect, useState } from 'react';
import { Table, message, Spin } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { HomeOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import {
  fetchSuperadminUnassignedUsers,
  PlatformUnassignedUser
} from '../../services/api';
import '../MemberManagement.css';

const SuperadminUnassignedUsers: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState<PlatformUnassignedUser[]>([]);

  const load = async () => {
    setLoading(true);
    try {
      const res = await fetchSuperadminUnassignedUsers();
      if (res.success && res.data) {
        setRows(res.data);
      } else {
        message.error(res.error || '加载失败');
      }
    } catch {
      message.error('加载失败');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const columns: ColumnsType<PlatformUnassignedUser> = [
    { title: '用户名', dataIndex: 'username', key: 'username', width: 120 },
    { title: '姓名', dataIndex: 'name', key: 'name', width: 120 },
    { title: '邮箱', dataIndex: 'email', key: 'email', ellipsis: true },
    {
      title: '注册时间',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 180,
      render: (v) => (v ? dayjs(v).format('YYYY-MM-DD HH:mm') : '—')
    }
  ];

  return (
    <div className="page-container full-height members-lims">
      <nav className="mm-crumb" aria-label="breadcrumb">
        <HomeOutlined />
        <span>首页</span>
        <span className="mm-crumb-sep">/</span>
        <span>平台管理</span>
        <span className="mm-crumb-sep">/</span>
        <span>未归属用户</span>
      </nav>

      <header className="mm-page-head">
        <div>
          <h1 className="mm-title">未归属团队用户</h1>
          <p className="mm-subtitle mb-0">
            自助注册等账号（teamId 为空），尚未进入真实实验室团队。不含平台超级管理员。
          </p>
        </div>
      </header>

      <div className="content-area px-1 px-md-2">
        <div className="am-table-shell bg-white rounded-3 border p-2 p-md-3">
          <Spin spinning={loading}>
            <Table<PlatformUnassignedUser>
              rowKey="_id"
              columns={columns}
              dataSource={rows}
              pagination={{ pageSize: 20, showSizeChanger: true }}
            />
          </Spin>
        </div>
      </div>
    </div>
  );
};

export default SuperadminUnassignedUsers;
